
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n        ', badge, '\n      ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatOption3(option, optionIndex) {
                    return _createElement('button', {
                        'key': option.value,
                        'type': 'button',
                        'className': 'cm_product-item__option-value',
                        'aria-pressed': option.active ? 'true' : 'false',
                        'onClick': e => window.Convermax.handleProductOptionClick(e.currentTarget, this, option)
                    }, '\n          ', option.value, '\n        ');
                }
                function repeatI4(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', {
                    'key': JSON.stringify(this.card_option?.values),
                    'className': 'cm_product-item grid-item__link' + (this.is_promotional_item ? ' cm_promotion' : '')
                }, _createElement('a', {
                    'href': this.url,
                    'className': 'cm_product-item__image-container'
                }, _createElement('img', {
                    'className': 'cm_product-item__image' + (this.image2 ? ' cm_product-item__image_primary' : ''),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'cm_product-item__image cm_product-item__image_secondary',
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '473'
                }) : null, this._badges ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_badge-container cm_badge-right',
                        'key': '703'
                    },
                    _map(this._badges, repeatBadge1.bind(this))
                ]) : null), _createElement('div', { 'className': 'cm_product-item__details' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'cm_product-item__title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), this.card_option?.values?.length ? _createElement('div', {
                    'className': 'cm_product-item__option',
                    'key': '1166'
                }, _createElement('div', { 'className': 'cm_product-item__option-title' }, this.card_option.name), _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_product-item__option-values' },
                    _map(this.card_option.values, repeatOption3.bind(this))
                ])) : null, _createElement('div', { 'className': 'cm_product-item__price-container' }, this.on_sale ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_compare',
                    'key': '1801'
                }, '\n        ', this.formatPrice(this.compare_at_price), '\n      ') : null, _createElement('div', { 'className': 'cm_product-item__price' }, this.price_varies ? _createElement('span', { 'key': '2004' }, _translate(`price_from`), ' ') : null, '\n        ', this.formatPrice(this.min_price || this.price), '\n      '), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_set',
                    'key': '2148'
                }, '\n        ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n      ') : null)), _createElement('div', { 'className': 'cm_product-item__sku-container' }, this.custom_mpn ? _createElement('div', {
                    'className': 'cm_product-item__sku',
                    'key': '2459'
                }, _createElement('span', { 'className': 'sku-title' }, 'Part number: '), _createElement('span', mergeProps({ 'className': 'sku-value' }, { dangerouslySetInnerHTML: { __html: typeof this.custom_mpn === 'undefined' ? '' : this.custom_mpn } }))) : null), _createElement('div', { 'className': 'cm_product-item__buttons' }, this.variant_ids.length === 1 || this.card_option ? _createElement('convermax-product-form', { 'key': '2801' }, _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'id': this.id,
                    'acceptCharset': 'UTF-8',
                    'className': 'form',
                    'encType': 'multipart/form-data',
                    'noValidate': 'novalidate',
                    'data-type': 'add-to-cart-form'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'form_type',
                    'value': 'product'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'utf8',
                    'value': '\u2713'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids[0],
                    'className': 'product-variant-id'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'product-id',
                    'value': this.id
                }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                    'type': 'hidden',
                    'name': 'properties[Fitment]',
                    'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                    'key': '3360'
                }) : null, _createElement('a', {
                    'href': this.url,
                    'className': 'quick-add__submit button button--full-width button--secondary btn-with-icon',
                    'aria-haspopup': 'dialog',
                    'aria-live': 'polite',
                    'data-sold-out-message': 'true'
                }, _createElement('span', {}, '\n            Shop now\n            ', _createElement('svg', {
                    'width': '9',
                    'height': '8',
                    'viewBox': '0 0 29 22',
                    'fill': 'none',
                    'xmlns': 'http://www.w3.org/2000/svg'
                }, _createElement('path', {
                    'd': 'M15.6387 15.6077C15.9826 15.1962 16.2265 14.7991 16.1814 14.7265C16.1241 14.6345 13.9509 14.5764 9.09723 14.534L2.09479 14.4735C-1.13935 11.7195 -0.355206 8.209 2.58382 7.45363C3.17284 7.30232 4.38748 7.27084 9.70821 7.27084C14.2692 7.27084 16.185 7.2309 16.3363 7.13405C16.5302 7.01058 16.4582 6.86895 15.607 5.68747C13.8021 3.1829 14.0899 1.49542 16.5241 0.299422C17.9497 -0.401473 19.1363 0.0924223 21.0021 2.16C21.5728 2.7919 22.4228 3.72884 22.8924 4.24332C23.3619 4.75779 24.4802 6.01674 25.3765 7.04205C26.2728 8.06616 27.3521 9.2319 27.7741 9.63137C28.9948 10.7874 29.0094 10.7438 26.4289 13.5741C25.6241 14.4565 24.6363 15.5496 24.2338 16.0036C21.3765 19.2224 19.5119 21.1362 18.8911 21.4836C18.657 21.6144 18.2387 21.6761 17.5802 21.6761C16.6119 21.6761 16.6119 21.6761 15.8119 20.922C13.9997 19.2151 13.9485 17.6402 15.6387 15.6077Z',
                    'fill': 'white'
                }))), _createElement('div', { 'className': 'loading__spinner hidden' }, _createElement('svg', {
                    'aria-hidden': 'true',
                    'focusable': 'false',
                    'className': 'spinner',
                    'viewBox': '0 0 66 66',
                    'xmlns': 'http://www.w3.org/2000/svg'
                }, _createElement('circle', {
                    'className': 'path',
                    'fill': 'none',
                    'strokeWidth': '6',
                    'cx': '33',
                    'cy': '33',
                    'r': '30'
                })))))) : null), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '51750'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI4.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '5574'
                }) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []